import { AnyAction } from '@reduxjs/toolkit';

export const isApiActions = (start: string, end: string, endpointName = '') => {
  return (action: AnyAction): boolean => {
    const { meta, type } = action;
    if (endpointName && meta?.arg?.endpointName !== endpointName) {
      return false;
    }
    return type.startsWith(start) && type.endsWith(end);
  };
};

export const isApiFetchingAction = (
  apiPath: string,
  endpointName = ''
): ((action: AnyAction) => boolean) => {
  return isApiActions(apiPath, 'pending', endpointName);
};

export const isApiFetchingCompletedAction = (
  apiPath: string,
  endpointName = ''
): ((action: AnyAction) => boolean) => {
  return isApiActions(apiPath, 'fulfilled', endpointName);
};
